import React, { createContext, useContext, useState, ReactNode } from 'react';

interface SplitPanelContextType {
  title: string;
  content: ReactNode;
  hidePreferencesButton: boolean;
  panelSize?: number;
  isOpen: boolean;
  setContent: (content: ReactNode) => void;
  sethidePreferencesButton: (boolean: boolean) => void;
  setTitle: (title: string) => void;
  setPanelSize: (panelSize: number) => void;
  closeView: () => void;
}

// Create context with default values
const SplitPanelContext = createContext<SplitPanelContextType>({
  title: '',
  content: null,
  panelSize: undefined,
  hidePreferencesButton: false,
  isOpen: false,
  sethidePreferencesButton: () => null,
  setContent: () => null,
  setTitle: () => null,
  setPanelSize: () => null,
  closeView: () => null,
});

export function SplitPanelProvider({ children }: { children: ReactNode }) {
  const [title, setTitle] = useState<string>('');
  const [content, setContent] = useState<ReactNode>(null);
  const [hidePreferencesButton, sethidePreferencesButton] = useState<boolean>(true);
  const defaultSize = Number(window.innerWidth * 0.3);
  const [panelSize, setPanelSize] = useState<number>(defaultSize);

  const value = {
    content,
    setContent,
    title,
    setTitle,
    hidePreferencesButton,
    panelSize,
    setPanelSize,
    sethidePreferencesButton,
    isOpen: content !== null,
    closeView: () => {
      setContent(null);
      setTitle('');
      setPanelSize(defaultSize);
    },
  };

  return (
    <SplitPanelContext.Provider value={value}>{children}</SplitPanelContext.Provider>
  );
}

export const useSplitPanel = () => useContext(SplitPanelContext);
